import React from 'react'
import { Select, SelectProps } from 'antd'
import type { SelectValue } from 'antd/es/select'

export type { SelectProps, SelectValue }

const defaultProps: SelectProps<SelectValue> = {
    showArrow: true,
    allowClear: true
}

const GylSelect = (props: SelectProps<SelectValue>) => {
    return <Select {...defaultProps} {...props} />
}

GylSelect.Option = Select.Option

export default GylSelect
